import { useState, useEffect } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { Fragment } from 'react';
import { ButtonTypes } from '../General/Button';
import { DefaultInputTypes } from '../Inputs/Types';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

export interface PopOverProps extends DefaultInputTypes {
  children: JSX.Element;
  bottomComponent?: JSX.Element;
  panelStyle?: string;
  shouldClose?: boolean;
  buttonType?: ButtonTypes;
  padding?: number;
}

const PopOver = ({
  children,
  color,
  bg = 'white border',
  name,
  label,
  shape,
  bottomComponent,
  panelStyle,
  buttonType = 'primary',
  shouldClose,

  padding = 2,
}: PopOverProps) => {
  const [typeState, setTypeState] = useState('');

  useEffect(() => {
    let newTypeState = `group flex  font-normal text-center outline-none  text-sm p-2  h-auto  md:h-9   ${
      shape === 'circle' ? 'rounded-full' : 'rounded-md'
    }  hover:bg-opacity-70   skip-focus`;
    switch (buttonType) {
      case 'text':
        newTypeState =
          newTypeState +
          `
          bg-transparent
           ${'hover:bg-' + (bg || 'ring-color')}
          ${'text-' + color}`;
        break;
      case 'ghost':
        newTypeState =
          newTypeState +
          ` bg-transparent
         border hover:bg-gray-200
           ${'text-' + color}`;
        break;
      case 'default':
        newTypeState =
          newTypeState +
          ` bg-transparent  shadow-none
           border ${'border-' + bg}
           ${'text-' + bg} font-semibold hover:text-primary`;
        break;
      case 'primary':
        newTypeState =
          newTypeState +
          `
           ${'bg-' + bg + ' shadow-sm'}
             border-gray-300
             ${'text-' + color}`;
    }
    setTypeState(newTypeState);
  }, [buttonType, bg, color]);
  return (
    <Popover className="w-auto h-full relative">
      {({ open }) => (
        <>
          <Popover.Button className={typeState}>
            <span>
              <ReturnTranslatedText
                origintext={typeof label === 'string' ? label || name : ''}
                text={`buttons.${label || name}`}
              />
            </span>
            <ChevronDownIcon
              className={`
                  ms-2 h-5 w-5 text-${color} group-hover:text-opacity-80 transition ease-in-out duration-150`}
              aria-hidden="true"
            />
          </Popover.Button>
          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel
              className={`absolute z-50 ${
                panelStyle ? panelStyle : 'w-screen'
              } max-w-sm px-1 rtl:right-2 ltr:left-2 mt-3 transform
              sm:px-0`}
            >
              {({ close }) => {
                if (shouldClose) {
                  close();
                }

                return (
                  <div className="overflow-hidden flex flex-col justify-between rounded-lg h-72 bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                    <div className={`${'p-' + padding}`}>{children}</div>
                    {bottomComponent && (
                      <div className=" justify-end"> {bottomComponent}</div>
                    )}
                  </div>
                );
              }}
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default PopOver;
